import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AirComponentType} from '../../../afb-api/enums/air-component-type.enum';

@Component({
  selector: 'awair-floor-plan-header',
  templateUrl: './floor-plan-header.component.html',
  styleUrls: ['./floor-plan-header.component.scss']
})

export class FloorPlanHeaderComponent implements OnInit {

  @Input() hasFloor: boolean = false;
  @Input() floorName: string = 'No floor plan';
  @Input() isSidebarOpened: boolean = false;
  @Input() selectedAirComponent: AirComponentType = AirComponentType.Score;

  @Output() openEditor: EventEmitter<void> = new EventEmitter<void>();
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectAirComponent: EventEmitter<AirComponentType> = new EventEmitter<AirComponentType>();

  constructor() {
  }

  ngOnInit() {
  }

  onOpenEditor(): void {
    this.openEditor.emit();
  }

  onSelectAirComponent(airComponent: AirComponentType): void {
    this.selectAirComponent.emit(airComponent);
  }

  onToggleSidebar(hasFloor: boolean): void {
    if (hasFloor) {
      this.isSidebarOpened = !this.isSidebarOpened;
      this.toggleSidebar.emit(this.isSidebarOpened);
    }
  }
}
